import { render, staticRenderFns } from "./SystemMessageEditor.vue?vue&type=template&id=a8312522&"
import script from "./SystemMessageEditor.vue?vue&type=script&lang=js&"
export * from "./SystemMessageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports